import { InjectionToken } from '@angular/core';
import { CultureCode } from './state/culture/culture';

export const IS_EPISERVER = new InjectionToken<boolean>(
    'Is running under Episerver'
);
export const CULTURE_CODE = new InjectionToken<CultureCode>(
    'Active culture code'
);
export const ENVIRONMENT = new InjectionToken<string>('Active environment');
